import { Controller } from 'react-hook-form'
import { Link } from 'react-router-dom'
import { appendStringWithValue, FormatISODateTime } from '../../../helpers/formatting'

export default function CreditForm(props) {
  const { control, responseData } = props

  return (
    <>
      <h3>
        On {FormatISODateTime(responseData?.created_at)}, Agent <Link to={`user/${responseData?.agent_user_id}`} className="is-link" target="_blank"><b>{responseData?.agent_user_label}</b></Link> requested manager approval to credit customer <Link to={`customer/${responseData?.customer_id}`} className="is-link" target="_blank"><b>{responseData?.customer_label}</b></Link> for Loan <Link to={`payment_schedule/${responseData?.customer_id}`} className="is-link" target="_blank"><b>{responseData?.loan?.label}</b></Link> with <b>{appendStringWithValue('Credit', responseData?.payment?.credit_reimbursement_amount)}{appendStringWithValue('Interest', responseData?.payment?.interest_amount)}{appendStringWithValue('Late Fee', responseData?.payment?.late_fee)}{appendStringWithValue('Loan Fee', responseData?.payment?.loan_fee)}{appendStringWithValue('NSF Fee', responseData?.payment?.nsf_fee)}{appendStringWithValue('Principal Amount', responseData?.payment?.principal_amount)}{appendStringWithValue('Scheduled Amount', responseData?.payment?.scheduled_amount)}</b>.
      </h3>
      <h3>{responseData?.description}</h3>

      <div className="divider m-0 my-2"></div>

      <h3>If approving you may modify these values:</h3><br />
      <div className="field is-horizontal manager-approval-modal-field">
        <label className={`manager-approval-modal-label`}>Principal Amount:</label>
        <Controller
          name="principal_amount"
          control={control}
          defaultValue={responseData?.payment?.principal_amount ?? 0}
          rules={{ required: true }}
          render={({ field }) => (
            <input {...field} type="number" className="input is-small lox-no-border" readOnly />
          )}
        />
      </div>

      <div className="field is-horizontal manager-approval-modal-field">
        <label className={`manager-approval-modal-label`}>Interest Amount:</label>
        <Controller
          name="interest_amount"
          control={control}
          defaultValue={responseData?.payment?.interest_amount ?? 0}
          rules={{ required: true }}
          render={({ field }) => (
            <input {...field} type="number" className="input is-small lox-no-border" readOnly />
          )}
        />
      </div>
      <div className="field is-horizontal manager-approval-modal-field">
        <label className={`manager-approval-modal-label`}>Late Fee:</label>
        <Controller
          name="late_fee"
          control={control}
          defaultValue={responseData?.payment?.late_fee ?? 0}
          rules={{ required: true }}
          render={({ field }) => (
            <input {...field} type="number" className="input is-small lox-no-border" readOnly />
          )}
        />
      </div>
      <div className="field is-horizontal manager-approval-modal-field">
        <label className={`manager-approval-modal-label`}>NSF Fee:</label>
        <Controller
          name="nsf_fee"
          control={control}
          defaultValue={responseData?.payment?.nsf_fee ?? 0}
          rules={{ required: true }}
          render={({ field }) => (
            <input {...field} type="number" className="input is-small lox-no-border" readOnly />
          )}
        />
      </div>
      <div className="field is-horizontal manager-approval-modal-field">
        <label className={`manager-approval-modal-label`}>Credit Reimbursement Amount:</label>
        <Controller
          name="credit_reimbursement_amount"
          control={control}
          defaultValue={responseData?.payment?.credit_reimbursement_amount ?? 0}
          rules={{ required: true }}
          render={({ field }) => (
            <input {...field} type="number" className="input is-small lox-no-border" readOnly />
          )}
        />
      </div>
    </>
  )
}
